// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeader_container__u1Bgf","innerContainer":"PageHeader_innerContainer__Gd_h5","title":"PageHeader_title__1wmQ3","description":"PageHeader_description__tbf_i"};